module.exports = __webpack_public_path__ + "static/img/4.0e3eec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/4.png
// module id = kfoY
// module chunks = 0